export var StatusEnum;
(function (StatusEnum) {
    StatusEnum["CREATED"] = "created";
    StatusEnum["ACTIVE"] = "active";
    StatusEnum["BLOCKED"] = "blocked";
    StatusEnum["DELETED"] = "deleted";
})(StatusEnum || (StatusEnum = {}));
export var GenderEnum;
(function (GenderEnum) {
    GenderEnum["MALE"] = "male";
    GenderEnum["FEMALE"] = "female";
})(GenderEnum || (GenderEnum = {}));
//# sourceMappingURL=User.js.map